import React from 'react';
import styled from 'styled-components/macro';

interface PropsI {
  title: string;
  width?: string;
  height?: string;
  mutedColor?: boolean;
  borderWidth?: number;
  children?: React.ReactNode;
}

const debug = false;
const CategoryContainer = (props: PropsI) => {
  const {title, width='max-content', height='max-content', mutedColor=false, borderWidth=1} = props;
  if (debug) console.log('CategoryContainer | props:', props);

  return (
    <BorderedContainer width={width} height={height} mutedColor={mutedColor} borderWidth={borderWidth}>
      <Header mutedColor={mutedColor}>{title}</Header>
      <Body>{ props.children }</Body>
    </BorderedContainer>
  );
};

export default CategoryContainer;

export const BorderedContainer = styled.div<{
  width: string;
  height: string;
  mutedColor: boolean;
  borderWidth: number;
  children?: React.ReactNode;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${(p) => p.width};
  height: ${(p) => p.height};
  background: ${(p) => p.theme.palette.backgroundPrimary};
  border: ${(p) => p.borderWidth}px solid ${(p) => p.mutedColor ? 
          p.theme.palette.textSecondary : p.theme.palette.accentSecondary};
  border-radius: 15px;
  margin: 10px;
`;

export const Header = styled.div<{
  mutedColor: boolean;
  children?: React.ReactNode;
}>`
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 14px;
  font-style: italic;
  font-weight: bold;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  background-color: ${(p) => p.mutedColor ? 
          p.theme.palette.textSecondary : p.theme.palette.accentSecondary};
  color: #000129;
`;

const Body = styled.div`
  display: flex;
`





